import {createRoot, hydrateRoot} from 'react-dom/client';
import SoundAndLighting from '../pages/SoundAndLighting/SoundAndLighting'
import "../index.css";
import "../pages/SoundAndLighting/SoundAndLighting.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SoundAndLighting {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SoundAndLighting {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SoundAndLightingVC = {mount, hydrate, unmount}